"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".full-width[_ngcontent-%COMP%]{width:100%}.new-password-card[_ngcontent-%COMP%]{min-width:120px;max-width:400px;margin:20px auto}.mat-radio-button[_ngcontent-%COMP%]{display:block;margin:5px 0}\n/*# sourceMappingURL=new-password.component.css.map*/"];
exports.styles = styles;
